import ShutterbugPhotoGroupPhotoViewerActions from './ShutterbugPhotoGroupPhotoViewerActions';

export default ShutterbugPhotoGroupPhotoViewerActions;
